<template>
  <div >
    <designTopMenu
      class="isntMainWrap"
    :phone="phone"
    :phoneForHref="phoneForHref"
    ></designTopMenu>
    <designTitleScreen
      class="isntMainWrap"
    ></designTitleScreen>
    <instForm
      class="isntMainWrap"
    ></instForm>

    <template v-if="selectedProduct === 'base'">
      <designInfoGetLoan
        class="isntMainWrap"
        :phone="phone"
        :phoneForHref="phoneForHref"
      ></designInfoGetLoan>
      <designOurAdvantages
        class="isntMainWrap"
      ></designOurAdvantages>
    </template>
    <template v-else>
      <clAdvantages class="isntMainWrap"></clAdvantages>
      <clConditions class="isntMainWrap"></clConditions>
      <clHowToGet class="isntMainWrap"></clHowToGet>
      <clComparison class="isntMainWrap"></clComparison>
    </template>

    <designPaymentInfo
      class="isntMainWrap"
      :ruStoreLink="ruStoreLink"
      :googleStoreLink="googleStoreLink"
    ></designPaymentInfo>
    <designFaq
      class="isntMainWrap"
      :ruStoreLink="ruStoreLink"
      :googleStoreLink="googleStoreLink"
    ></designFaq>
<!--    <banner></banner>-->
    <designFooter
      :phone="phone"
      :phoneForHref="phoneForHref"
    >
    </designFooter>
  </div>
</template>
<script>
import {mapState, mapGetters} from 'vuex';
// import testData from "@/store/Form/testData";
import "@/assets/css/fontRoboto.css";
import "@/assets/css/fontUbuntu.css";
import "@/assets/css/variable.css";
import "@/assets/css/instDesignLnd25.css";
import "@/assets/css/instInputs.css";


/* eslint-disable vue/no-unused-components */
export default {
  name: "instLnd",
  data() {
    return {
      phone:'8 800 600 99 90',
      ruStoreLink:'https://www.rustore.ru/catalog/app/ru.finmoll.customer',
      googleStoreLink:'',
    }
  },
  components: {
    instForm: () => import('@/components/inst/instForm.vue'),
    designTopMenu: () => import('@/components/inst/design/topMenu.vue'),
    designTitleScreen: () => import('@/components/inst/design/titleScreen.vue'),
    designInfoGetLoan: () => import('@/components/inst/design/infoGetLoan.vue'),
    designOurAdvantages: () => import('@/components/inst/design/ourAdvantages'),
    designPaymentInfo: () => import('@/components/inst/design/paymentInfo'),
    designFaq: () => import('@/components/inst/design/faq.vue'),
    designFooter:() => import('@/components/inst/design/instfooter.vue'),
    // banner: () => import('@/components/banner/goToLk.vue'),
    clAdvantages: () => import('@/components/inst/design/creditLine/clAdvantages.vue'),
    clConditions: () => import('@/components/inst/design/creditLine/clConditions.vue'),
    clHowToGet: () => import('@/components/inst/design/creditLine/clHowToGet.vue'),
    clComparison: () => import('@/components/inst/design/creditLine/clComparison.vue'),
  },
  computed: {
    ...mapState({
      selectedProduct: state => state.Deal.selectedProduct,
    }),
    ...mapGetters([]),
    phoneForHref(){
      return 'tel:' + this.phone.replace(/\D+/g, "").toString();
    }
  },
  methods: {
    // если DaData не нашла подсказку по строке адреса - поле НЕ трогаем,
    // оно остаётся пустым для ручного ввода (по примеру pdlLoan.vue saveDadataAddress)
    saveDadataAddressOrEmpty(refs, value) {
      this.$myApi.suggestResult(refs, {'value': value, 'type': refs}).then((res) => {
        if (res.data.result.suggestions.length > 0) {
          const suggestion = res.data.result.suggestions[0];
          this.$store.dispatch('saveSendData', {target: refs + '_DADATA', value: suggestion});
          this.$store.dispatch('saveSendData', {target: refs, value: suggestion.value});
        }
      }).catch((res) => {
        console.log(res);
      });
    },
    getCreditLineClientData() {
      const guid = this.$route.query.subid;
      if (!guid) return;

      // поля p_ExternalExecute_CreditLineClientData 1:1 с внутренними именами формы
      const clAlias = [
        'LAST_NAME', 'FIRST_NAME', 'SECOND_NAME', 'BIRTHDAY', 'GENDER', 'PHONE', 'EMAIL',
        'PASSPORT_SERIES', 'PASSPORT_NUMBER', 'PASSPORT_DATE', 'PASSPORT_DEP', 'PASSPORT_DEP_CODE',
        'SOURCE_OF_INCOME', 'WORK_JOB', 'WORK_JOB_PHONE', 'EXPER_RADIO', 'WORK_TITLE',
        'CONST_INCOME', 'AVERAGE_EXPENSES_PER_MONTH', 'PURPOSE_OF_THE_LOAN', 'CONTACT', 'CONTACT_PHONE',
      ];
      const clAddressAlias = [
        {value: 'RESIDENTIAL_ADDRESS', dadata: 'RESIDENTIAL_ADDRESS_DADATA'},
        {value: 'REGISTRATION_ADDRESS', dadata: 'REGISTRATION_ADDRESS_DADATA'},
      ];
      // бэк присылает [] вместо объекта, когда дадаты нет - не считаем это "объектом дадаты"
      const isRealDadataObject = (value) => {
        return !!value && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length > 0;
      };

      this.$external.run({
        action: 'getCreditLineClientData',
        guid: guid
      }).then((res) => {
        const workData = res?.ExecutionResult;
        if (!workData || Object.keys(workData).length === 0) return;

        clAlias.forEach((field) => {
          if (workData[field] !== undefined && workData[field] !== null) {
            this.$store.dispatch('saveSendData', {target: field, value: workData[field]});
          }
        });

        clAddressAlias.forEach((addr) => {
          if (isRealDadataObject(workData[addr.dadata])) {
            // бэк уже прислал объект дадаты - используем как есть
            this.$store.dispatch('saveSendData', {target: addr.dadata, value: workData[addr.dadata]});
            this.$store.dispatch('saveSendData', {target: addr.value, value: workData[addr.value] || workData[addr.dadata].value});
          } else if (workData[addr.value]) {
            // объекта дадаты нет (или пришёл []) - пробуем найти по известной строке адреса (по примеру pdlLoan.vue)
            // если и тут не найдётся - поле останется пустым для ручного ввода
            this.saveDadataAddressOrEmpty(addr.value, workData[addr.value]);
          }
        });
      }).catch((res) => {
        console.log(res);
      });
    },
    saveDadataAddress(refs, value) {
      let result = undefined;
      this.$myApi.suggestResult(refs, {'value': value, 'type': refs}).then((res) => {
        if (res.data.result.suggestions.length > 0) {
          result = res.data.result.suggestions[0];
          console.log(result)
          this.$store.dispatch('saveSendData', {
            target: refs + '_DADATA',
            value: result,
          });
        }
      }).catch((res) => {
        console.log(res);
      }).finally(() => {
        this.$store.dispatch('saveSendData', {
          target: refs,
          value: result !== undefined ? result.value : value
        });
      });
    },
    getFromNsk() {
      const nskAlias = [
        {nsk: 'lastName', msk: 'LAST_NAME'},
        {nsk: 'firstName', msk: 'FIRST_NAME'},
        {nsk: 'middleName', msk: 'SECOND_NAME'},
        {nsk: 'phone', msk: 'PHONE'},
        {nsk: 'email', msk: 'EMAIL'},
        {nsk: 'passportSerie', msk: 'PASSPORT_SERIES'},
        {nsk: 'passportNumber', msk: 'PASSPORT_NUMBER'},
        {nsk: 'passportIssueDate', msk: 'PASSPORT_DATE'},
        {nsk: 'birthPlace', msk: 'BIRTHPLACE'},
        {nsk: 'orgName', msk: 'WORK_JOB'},
        {nsk: 'orgPosition', msk: 'WORK_TITLE'},
        {nsk: 'address', msk: 'REGISTRATION_ADDRESS'},
        {nsk: 'birthDate', msk: 'BIRTHDAY'},
        {nsk: 'passportIssuerCode', msk: 'PASSPORT_DEP_CODE'},
        {nsk: 'passportIssuer', msk: 'PASSPORT_DEP'},

      ];

      try {
        if (this.$route.query.subid !== undefined) {
          this.$axios({
            method: 'post',
            url: process.env.VUE_APP_URL_API_MS + '/getNskData.php',
            data: {
              session_id: this.$myApi.sessionId(),
              guid: this.$route.query.subid
            }
          }).then((res) => {
            const workData = res?.data?.result?.client;
            if (workData && Object.keys(workData).length > 0 && workData.constructor === Object) {
              nskAlias.forEach((item) => {
                if (workData[item.nsk] !== undefined && workData[item.nsk] != null) {
                  if (item.nsk === 'address') {
                    console.log('address')
                    this.saveDadataAddress(item.msk, workData[item.nsk])
                  } else {
                    this.$store.dispatch('saveSendData', {
                      target: item.msk,
                      value: workData[item.nsk]
                    });
                  }
                }
              });
            }


          }).catch((res) => {
            console.log(res)
          }).finally(() => {
            // setTimeout(()=>{
            this.WsScrollTo('zform');
            // },500)
            if (this.$route.query.sub1 && parseInt(this.$route.query.sub1, 10) > 0 && this.$route.query.sub1 % 1000 === 0) {
              const addCalcSumm = parseInt(this.$route.query.sub1, 10);
              if (addCalcSumm >= this.minBaseProduct.Amount && addCalcSumm <= this.maxBaseProduct.Amount) {
                this.$store.dispatch('setDealStateRange', {type: 'SelectedSumm', value: addCalcSumm});
                this.$store.dispatch('saveSendData', {
                  target: 'CALC_SUMM',
                  value: addCalcSumm
                })
              }
            }
          })
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
  mounted() {

    setTimeout(()=>{
      //костыль для загрузки
      this.googleStoreLink = window.outerWidth <= 760
        ? 'https://dfin-test.onelink.me/EX3r?af_ios_url=https%3A%2F%2Flnd.msk.finmoll.com%2Fadmd%2F%3Futm_source%3Dapp_ios_mobile&af_xp=custom&pid=mobile_banner'
        : 'https://dfin-test.onelink.me/EX3r?af_ios_url=https%3A%2F%2Flnd.msk.finmoll.com%2Fadmd%2F%3Futm_source%3Dapp_ios&af_web_dp=https%3A%2F%2Flnd.msk.finmoll.com%2Fadmd%2F%3Futm_source%3Dapp_banner_site_desktop&af_xp=custom&pid=banner_site';
    },500);


    this.$store.dispatch('getDiealInfo');
    try {
      if (this.$route.query.Partner_Id !== undefined) {
        switch (parseInt(this.$route.query.Partner_Id, 10)) {
          case 10004:
            this.getFromNsk();
            break;
          case 10006:
            this.getFromNsk();
            break;
          case 9:
            this.getCreditLineClientData();
            break;
        }
      }
    } catch (e) {
      //todo метрика проблем с клиентами он нск
      console.log(e)
    }




    this.$store.dispatch('inst_initForm', 'Client');

    if (process.env.NODE_ENV === 'development') {
      // testData.testDataForForm.forEach((item) => {
      //   if (item.target.includes('_ADDRESS')) {
      //     this.saveDadataAddress(item.target, item.value);
      //   } else {
      //     this.$store.dispatch('saveSendData', {
      //       target: item.target,
      //       value: item.value
      //     });
      //   }
      // });
      this.$store.dispatch('saveSendData', {
        target: 'AGREEMENT_ALL',
        value: true
      });
      //this.$store.dispatch('inst_initForm', 'Passport');
      // this.$store.dispatch('inst_initForm', 'WorkInfo');
      // this.$store.dispatch('inst_initForm', 'smsConfirm');
    }

    // this.$store.dispatch('readCookie');

    if (window.ym) {
      // eslint-disable-next-line no-undef
      ym(51632228, "init", {
        clickmap:true,
        trackLinks:true,
        accurateTrackBounce:true,
        webvisor:true,
        // userParams: {
        //   // session_id: session_id,
        //   // partner_id: partner_id,
        // }
      });
      // eslint-disable-next-line no-undef
      ym(51632228, 'reachGoal', 'allEnter');
      // eslint-disable-next-line no-undef
      ym(51632228, 'reachGoal', 'lendNotAdmd');
      // eslint-disable-next-line no-undef
      ym(51632228, 'reachGoal', 'instLoad');
    }
    try {
      const isDevelopment = process.env.NODE_ENV === 'development';
      const hasJivoWidget = !!document.getElementById('jivo_ru_widget');

      if (!isDevelopment && !hasJivoWidget) {
        let s;
        s = document.createElement('script');
        s.id = 'jivo_ru_widget';
        s.src = '//code.jivo.ru/widget/vtkA8XaWDb';
        document.head.appendChild(s);
      }
    } catch ($error) {
      console.log($error);
    }
  },
  watch: {}
}
</script>
<style scope>
* {
  margin: 0;
  padding: 0;
}

html, body {
  margin: 0;
  padding: 0;
  font-family: 'Ubuntu';
  font-weight: 500;
}


</style>
